import get from 'transmute/get';
import getIn from 'transmute/getIn';
const AUTHORIZATION_ERROR = 'UNAUTHORIZED';
export const isAuthorizationError = error => {
  const getErrorMessage = get('message');
  const graphQLError = getIn(['graphQLErrors', '0', 'extensions', 'ERROR_CODE'], error);
  return error && getErrorMessage(error).includes(AUTHORIZATION_ERROR) || graphQLError && graphQLError.includes(AUTHORIZATION_ERROR);
};